import React, { useState } from "react";
import { BestCTReportParams, BestCTReportDto } from "../../../_models"
import BestCTReportFilters from "../filters/BestCTReportFilters";
import BestCTReportList from "./BestCTReportList";
import { useDispatch, useSelector } from "react-redux";
import { reportActions } from "../../../_redux/actions";
import { utilFunctions } from "../../../_helpers";
import { Typography, Grid } from "@material-ui/core";

const BestCTReport = (props) => {
    const dispatch = useDispatch();
    const sbuListState = useSelector((state: any) => state.factories.sbuList);
    const initialReportData = [{
        gsdCode: '',
        operationName: '',
        ssv: null,
        bestCTs: [],
        bestCT: null,
        teamMemberName: [],
        cycleCounts: []
    }];

    const [totalSSV, setTotalSSV] = useState(0);
    const [totalBestCT, setTotalBestCT] = useState(0);
    const [moduleOrPlants, setModuleOrPlants] = useState([]);
    const [bestCTTotals, setBestCTTotals] = useState([]);
    const [cycleCountTotals, setCycleCountTotals] = useState([]);
    const [organizedItems, setOrganizedItems] = useState(initialReportData);
    const [reportDataExists, setReportDataExists] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const onFilterApply = (filters: BestCTReportParams) => {
        setIsLoading(true);
        setReportDataExists(false);
        dispatch(reportActions.getBestCTReportData(
            filters
            , (res: BestCTReportDto) => {
                if (res.organizedItems && res.organizedItems.length > 0) {
                    setTotalSSV(res.totalSSV)
                    setTotalBestCT(res.totalBestCT)
                    setModuleOrPlants(res.moduleOrPlants)
                    setBestCTTotals(res.bestCTTotals)
                    setCycleCountTotals(res.cycleCountTotals)
                    setOrganizedItems(res.organizedItems)
                    setIsLoading(false)
                    setReportDataExists(true);
                } else {
                    setIsLoading(false)
                    setOrganizedItems(initialReportData);
                }
            }
            , () => {
                setIsLoading(false);
                setReportDataExists(false);
            }
        ));
    }

    const onDownloadClick = (filters: BestCTReportParams) => {
        dispatch(reportActions.downloadBestCTReportData(filters))
    }

    const onFilterClear = () => {
        setIsLoading(false);
        setReportDataExists(false)
        setTotalSSV(0)
        setTotalBestCT(0)
        setModuleOrPlants([])
        setBestCTTotals([]);
        setCycleCountTotals([]);
        setOrganizedItems(initialReportData);
        setReportDataExists(false);
    }

    return (
        <React.Fragment>
            <BestCTReportFilters
                isLoading={isLoading}
                onFilterClear={() => onFilterClear()}
                onFilterApply={(filters) => onFilterApply(filters)}
                onDownloadClick={(filters) => onDownloadClick(filters)}
                sbus={sbuListState.data} />
            {reportDataExists &&
                (<BestCTReportList
                    totalSSV={totalSSV}
                    totalBestCT={totalBestCT}
                    moduleOrPlants={moduleOrPlants}
                    bestCTTotals={bestCTTotals}
                    cycleCountTotals={cycleCountTotals}
                    organizedItems={organizedItems} />)
            }
            {!reportDataExists && !isLoading && <Grid style={{ background: 'white', padding: '5px' }}><Typography>NO DATA FOUND.</Typography></Grid>}
        </React.Fragment>
    )
}

export default BestCTReport;

